module.exports = __webpack_public_path__ + "img/step_3.ff948bf9.webp";